export default class ListPosts {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  async execute({ 
    limit = 10, 
    lastVisible = null, 
    refresh = false 
  } = {}) {
    try {
      // Toujours utiliser le tri ascendant par date d'activité
      const orderBy = {
        field: 'activity.date',
        direction: 'asc'  // Changé en 'asc' pour avoir du plus proche au plus lointain
      };

      const result = await this.postRepository.getPosts({
        limit,
        lastVisible,
        orderBy,
        refresh,
        // Ne pas spécifier de dateFilter ici car le repository gère maintenant H-1
      });

      return {
        posts: result.posts,
        lastVisible: result.lastVisible,
        hasMore: result.hasMore
      };
    } catch (error) {
      console.error('[ListPosts] error:', error);
      throw error;
    }
  }
} 